import React, { useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { ShepherdTour, ShepherdTourContext } from 'react-shepherd';

import { AuthContext } from 'context/AuthContext';
import { useAppContext } from 'utils/hooks';
import { getTourOptions } from 'containers/TourGuides/methods';
import { getSteps } from './methods';
import { UiKit } from 'components';

export function WelcomeTour({ children }) {
  const { push } = useHistory();
  const { isSSREnv, appName, supportEmail } = useAppContext();

  const steps = useRef(getSteps({ push, isSSREnv, appName, supportEmail }))
    .current;
  const tourOptions = useRef(getTourOptions({ tourName: 'app-tour' })).current;

  return (
    <ShepherdTour steps={steps} tourOptions={tourOptions}>
      {children}
    </ShepherdTour>
  );
}

export function WelcomeTourTrigger() {
  const { updateState } = useContext(AuthContext);
  const tour = useContext(ShepherdTourContext);

  const onTourStart = () => {
    tour.start();
    updateState({ isTourShown: true, showTour: false });
  };

  return (
    <UiKit.Button
      variant="outline"
      onClick={onTourStart}
      processingText="Loading"
    >
      Start
    </UiKit.Button>
  );
}
